var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-body" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "control-label col-md-3" }, [
            _vm._v("Kwota")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.price,
                  expression: "price"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "number", step: "0.01", min: "0.01" },
              domProps: { value: _vm.price },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.price = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.priceError,
                  expression: "priceError"
                }
              ],
              style: { color: "red", margin: "10px, 0, 0, 15px" }
            },
            [
              _vm._v(
                "\n                Kwota musi być większa od zera\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.priceMaxError,
                  expression: "priceMaxError"
                }
              ],
              style: { color: "red", margin: "10px, 0, 0, 15px" }
            },
            [
              _vm._v(
                "\n                Kwota nie może być większa od kwoty pozostałej do zapłaty.\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6" },
        [
          _c("number-input", {
            attrs: { name: "activityTime", title: "Czas aktywności linka (h)" },
            model: {
              value: _vm.time,
              callback: function($$v) {
                _vm.time = $$v
              },
              expression: "time"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.surchargeUri != "",
                expression: "surchargeUri != ''"
              }
            ],
            staticClass: "surcharge-uri"
          },
          [_vm._v(_vm._s(_vm.surchargeUri))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf3cc4f", { render: render, staticRenderFns: staticRenderFns })
  }
}